/**
 * セクションテンプレートVO
 *
 * @export SectionTemplateModel
 * @class SectionTemplateModel
 */
export class SectionTemplateModel {
  public sectionTemplateID = String('');
  public sectionTemplateName = String('');
  // 項番2231 START 障害管理NO.U01748対応
  // public positionX: number = Number(0);
  // public positionY: number = Number(0);
  // public width: number = Number(0);
  // public height: number = Number(0);
  public positionX = String(0);
  public positionY = String(0);
  public width = String(0);
  public height = String(0);
  // 項番2231 END 障害管理NO.U01748対応
  public divW = Number(0);
  public divH = Number(0);
  public percentWidth = Number(0);
  public percentHeight = Number(0);
  public percentPositionX = Number(0);
  public percentPositionY = Number(0);
  // 項番2231 START 障害管理NO.U01748対応
  // public percentWidthDisplay: number = Number(0);
  // public percentHeightDisplay: number = Number(0);
  // public percentPositionXDisplay: number = Number(0);
  // public percentPositionYDisplay: number = Number(0);
  public percentWidthDisplay = String(0);
  public percentHeightDisplay = String(0);
  public percentPositionXDisplay = String(0);
  public percentPositionYDisplay = String(0);
  // 項番2231 END 障害管理NO.U01748対応
}
